import styled from "styled-components";
import { useSelector } from "react-redux";
import HomeButtonPrimaryDesktop from "./HomeButtonPrimaryDesktop";
import { useNavigate } from "react-router-dom";
import HomeButtonSecondaryDesktop from "./HomeButtonSecondaryDesktop";

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
`;

const SecondaryWrapper = styled.div`
  // padding-top: 12px;
  display: ${(props) => (props.$buttonsInLine ? "flex" : "")};
`;

const SecondaryButtonWrapper = styled.div`
  padding-top: 10px;
  width: 350px;
`;

const ButtonPanelDesktop = () => {
  const navigate = useNavigate();
  const screenWidth = useSelector((state) => state.screenWidth.value);
  // determined by 24 + 24 (margin) + 350 + 350 (secondary button wrapper widths)
  const buttonsInLine = screenWidth >= 748;

  return (
    <>
      <ButtonWrapper>
        <HomeButtonPrimaryDesktop
          text="SIGN IN"
          onClick={() => {
            navigate("/signin");
          }}
        />
      </ButtonWrapper>
      <SecondaryWrapper $buttonsInLine={buttonsInLine}>
        <SecondaryButtonWrapper>
          <HomeButtonSecondaryDesktop
            text="Browse Petitions"
            onClick={() => {
              navigate("/petitions");
            }}
          />
        </SecondaryButtonWrapper>
        <SecondaryButtonWrapper>
          <HomeButtonSecondaryDesktop
            text="About Verified Voice"
            onClick={() => {
              navigate("/about");
            }}
          />
        </SecondaryButtonWrapper>
      </SecondaryWrapper>
    </>
  );
};

export default ButtonPanelDesktop;
